import Icon from '../Controls/Icon/Icon';
import { Icons } from 'src/assets/fonts/Icons/icons';
import { ORDER_STATUS } from 'src/constants/order';
import { orderColorByStatus } from 'src/mobx/ordersHistoryStore/types';

const OrderStatusIcon = ({ status, size = 24 }: { status: ORDER_STATUS; size?: number }) => {
  // const orderDeliveryTypeIconNameMap = {
  //   [OrderDeliveryType.Delivery]: <Icon name={Icons.Delivery} size={size} />,
  //   [OrderDeliveryType.DineIn]: <Icon name={Icons.DineIn} size={size} />,
  //   [OrderDeliveryType.Curbside]: <Icon name={Icons.Curbside} size={size} />,
  //   [OrderDeliveryType.Pickup]: <Icon name={Icons.ShoppingBag} size={size} />,
  //   [ORDER_STATUS]
  // };
  return <Icon name={Icons.Circle} size={size} color={orderColorByStatus[status]} />;
};

export default OrderStatusIcon;
